import React from 'react'
import { SafeSEO, type SafeSEOProps } from './SafeSEO'

type MarketingSEOProps = SafeSEOProps & {
  schemas?: Array<Record<string, unknown>>
  includeOrg?: boolean
  includeWebsite?: boolean
}

export function MarketingSEO({
  schemas = [],
  includeOrg = true,
  includeWebsite = true,
  ...seo
}: MarketingSEOProps) {
  const siteUrl = 'https://www.joeyfamily.com'

  const org = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Joey',
    url: siteUrl,
    logo: `${siteUrl}/img/logo.png`,
  }

  const website = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Joey',
    url: siteUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/articles?q={query}`,
      'query-input': 'required name=query',
    },
  }

  return (
    <>
      <SafeSEO {...seo} />
      {includeOrg && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(org) }}
        />
      )}
      {includeWebsite && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(website) }}
        />
      )}
      {schemas.map((schema, idx) => (
        <script
          key={idx}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  )
}
